<div [class]="avatarClass" [ngStyle]="customSizeStyle" [style.background-color]="customBgColor"
  [style.color]="customTextColor">
  <!-- Image (role-resolved: company logo for admin/sub_admin, personal image for employee) -->
  @if (showImage) {
  <img [src]="resolvedSrc" [alt]="resolvedAlt" class="avatar-image" (error)="onImageError()" />
  }

  <!-- Initials fallback (employees only — never shown for company logo roles) -->
  @if (!showImage && computedInitials) {
  <span class="avatar-initials">{{ computedInitials }}</span>
  }

  <!-- Icon fallback (no image, no name) -->
  @if (!showImage && !computedInitials) {
  <i class="fa-solid fa-user avatar-icon"></i>
  }

  <!-- Status dot -->
  @if (status) {
  <span class="avatar-status-badge" [ngClass]="'status-' + status" [attr.aria-label]="status + ' status'"></span>
  }
</div>